/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:37:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:09:52                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * ProspectDashCard - Display visit
*/

/* Imports */
import { BuildingOfficeIcon, CalendarIcon, MapPinIcon, UsersIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
import AddressDisplay from "../address/AddressDisplay";
import ContactDisplay from "../contact/ContactDisplay";
/***/

/* Styles */
import "./ProspectDashCard.scss";
import DateDisplay from "../date/DateDisplay";
import { t } from "../../../i18n";
import CustomerDisplay from "../customer/CustomerDisplay";
import { getProspectHour } from "../../../services/prospect/prospect";
/***/

/**
* ProspectDashCard - Display visit
* @param visit - visit data
* @param onClick - on click event, trigger on component click
*/
export default function ProspectDashCard({
  visit,
  onClick
}: {
  visit: EasyTech.Prospect,
  onClick?: () => void
}) {
  return (
  <div className="visit-card" onClick={() => onClick && onClick()}>
    <div className="flex justify-between ">
      <Typography className="text-blue-600 hover:underline">
        {visit.ref}
      </Typography>
    </div>
    
    
    <div className="icon-text-container">
      <div className="icon-text">
        <BuildingOfficeIcon className="w-5" />
        <CustomerDisplay customer={visit.customer} />
      </div>
      {visit.customer.address && (
        <div className="icon-text">
          <MapPinIcon className="w-5" />
          <AddressDisplay address={visit.customer.address} />
        </div>
      )}
    </div>

    <div className="icon-text-container">
      <div className="icon-text">
        <UsersIcon className="w-5"/>
        <ContactDisplay contact={visit.contact} short={true}/>
      </div>

      <div className="icon-text">
        <CalendarIcon className="w-5"/>
        {t("common:doneOn") + " "}<DateDisplay date={new Date(visit.date)}/>{getProspectHour(visit) ? ` ${getProspectHour(visit)}` : ""}
      </div>
    </div>
  </div>
  );
}
/***/
